
import React from 'react'
import PropTypes from 'prop-types'
import { modalActionsCss } from './styles'

export default function ModalActions({ children, ...props }) {
  return (
    <div
      css={modalActionsCss}
      className="papui_modal__actions"
      data-testid="modal-actions"
      {...props}
    >
      {children}
    </div>
  )
}

ModalActions.propTypes = {
  children: PropTypes.any,
}
